import React, { useEffect, useState } from 'react'
import { Button, Col, Divider, Drawer, Input, Row, Select, Typography, message, DatePicker, Radio } from 'antd'
import moment from 'moment'
import Utils from '../../../utils/Utils'
import Cleave from 'cleave.js/react'
import inventorySrc from '../../inventory/inventorySrc'

const { Title } = Typography
const { Option } = Select

function FelDrawer(props) {
  const [company_id, setCompanyId] = useState('')
  const [store_id, setStoreId] = useState('')
  const [tradename, setTradeName] = useState('')
  const [reason, setReason] = useState('')
  const [address, setEmisorAddress] = useState('')
  const [email, setEmisorEmail] = useState('')
  const [rtn, setRtn] = useState('')
  const [cai, setCai] = useState('')
  const [denomination, setDenomination] = useState('')
  const [documentType, setDocumentType] = useState('')
  const [limitDate, setLimitDate] = useState('')
  const [startRange, setStartRange] = useState(0)
  const [endRange, setEndRange] = useState(1)
  const [loadingField, setLoadingField] = useState(true)
  const [enterprises, setEnterprises] = useState([])
  const [active, setActive] = useState(false)
  const [establishmentTaxpayer, setEstablishmentTaxpayer] = useState('')
  const [shopsList, setShopsList] = useState([])
  const [phone, setPhone] = useState('')

  const loadInformation = () => {
    setCompanyId(props.edit ? props.editData.company_id : '')
    setStoreId(props.edit ? props.editData.store_id : '')
    setTradeName(props.edit ? props.editData.tradename : '')
    setReason(props.edit ? props.editData.reason : '')
    setEmisorAddress(props.edit ? props.editData.address : '')
    setEmisorEmail(props.edit ? props.editData.email : '')
    setRtn(props.edit ? props.editData.rtn : '')
    setCai(props.edit ? props.editData.cai : '')
    setDenomination(props.edit ? props.editData.denomination : '')
    setDocumentType(props.edit ? props.editData.document_type : '')
    setLimitDate(props.edit ? props.editData.emission_limit_date : '')
    setStartRange(props.edit ? props.editData.start_authorized_range : '')
    setEndRange(props.edit ? props.editData.end_authorized_range : '')
    setActive(props.edit && props.editData.active === 1 ? true : false)
    setEstablishmentTaxpayer(props.edit ? props.editData.establishment_taxpayer : '')
    setPhone(props.edit ? props.editData.phone : '')
  }

  useEffect(() => {
    loadInformation()

    if (props.visible) {
      onSearchEnterprise('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible])

  useEffect(() => {
    const fetchShops = () => {
      inventorySrc
        .getAllStores()
        .then(response => {
          const shopsHonduras = response.data.filter(element => element.company && element.company.country && element.company.country.name === 'Honduras')

          setShopsList(shopsHonduras)
        })
        .catch(err => {
          console.log(err)
          message.error('Error al cargar tiendas')
        })
    }
    fetchShops()
  }, [])

  const saveData = () => {
    let data = {
      company_id: validateParams(company_id, 'Empresa', false) ? company_id : undefined,
      store_id: validateParams(store_id, 'Tienda', false) ? store_id : undefined,
      tradename: validateParams(tradename, 'Nombre Comercial') ? tradename : undefined,
      reason: validateParams(reason, 'Razón Social') ? reason : undefined,
      address: validateParams(address, 'Domicilio / Dirección') ? address : undefined,
      email: validateParams(email, 'Correo del emisor') ? email : undefined,
      rtn: validateParams(rtn, 'RTN', false) ? rtn : undefined,
      cai: validateParams(cai, 'CAI') ? cai : undefined,
      denomination: validateParams(denomination, 'Denominacion') ? denomination : undefined,
      document_type: validateParams(documentType, 'Tipo de documento') ? documentType : undefined,
      emission_limit_date: validateParams(limitDate, 'Fecha limite') ? limitDate : undefined,
      // authorized_range_basis: validateParams(range, 'Rango de autorizacion basico') ? range : undefined,
      establishment_taxpayer: validateParams(establishmentTaxpayer, 'Establecimiento del obligado tributario') ? establishmentTaxpayer : undefined,
      start_authorized_range: validateParams(startRange, 'Inicio de rango') ? startRange : undefined,
      end_authorized_range: validateParams(endRange, 'Fin de rango') ? endRange : undefined,
      fel_id: props.edit ? props.editData.fel_id : 0,
      is_active: active,
      phone: phone
    }

    let boolValidate = true
    for (let k in data) {
      if (boolValidate) {
        const d = data[k]
        d === '' || d === undefined || d === null ? (boolValidate = false) : (boolValidate = true)
      }
    }

    if (parseInt(startRange) >= parseInt(endRange)) {
      return message.warning(`El rango inicial debe ser menor que el rango final`)
    } else {
      data.authorized_range_basis = null
      if (boolValidate) {
        props.saveButton(data, props.edit)
      }
    }
  }

  const validateParams = (val, strMessage, boolInteger = false, paramsMessage) => {
    if (val === '' || val === null) {
      if (boolInteger) {
        return !Number.isInteger(val * 1) || val * 1 <= 0 ? message.warning(strMessage) : true
      }
      return message.warning(`El campo ${strMessage} no debe estar vacio`)
    } else {
      return true
    }
  }

  const onSearchEnterprise = val => {
    const excludeChars = Utils.excludedCharsContent(val)
    Utils.getEnterpriseOptionHonduras(val, excludeChars, 'desc')
      .then(response => {
        setEnterprises(response.data.data)
        setLoadingField(false)
      })
      .catch(err => {
        console.log(err)
        message.error('No se ha podido cargar la información de empresa')
      })
  }

  const onChangeBirthDate = (date, dateString) => {
    setLimitDate(dateString)
  }

  const denominationData = [
    { id: '01', name: 'Factura' },
    { id: '02', name: 'Factura Prevalorada' },
    { id: '03', name: 'Ticket' },
    { id: '04', name: 'Recibo por Honorarios Profesionales' },
    { id: '05', name: 'Boleta de Compra' },
    { id: '06', name: 'Constancia de Donación' },
    { id: '07', name: 'Nota de Crédito' },
    { id: '08', name: 'Nota de Débito' },
    { id: '09', name: 'Guía de Remisión' },
    { id: '10', name: 'Comprobante de Retención' }
  ]

  const setDenominationType = (value) => {
    setDocumentType(value)

    const found = denominationData.find(element => element.id === value)

    setDenomination(found.name)
  }

  const setStoreCompany = (value) => {
    setStoreId(value)
    const data = shopsList.filter(element => element.id === value)
    const { company_id } = data[0]
    setCompanyId(company_id)
  }

  return (
    <Drawer className={'entreprise-drawer'} placement="right" closable={false} onClose={props.closable} visible={props.visible} width={800}>
      <Row gutter={16}>
        <Title> {props.edit ? 'Editar Credencial' : 'Nueva Credencial'} </Title>
        <Divider className={'divider-custom-margins-users'} />
        <Row gutter={16} className={'section-space-field'}>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Tienda*</div>
            <Select
              disabled={loadingField}
              showSearch
              optionFilterProp="children"
              onSearch={onSearchEnterprise}
              value={store_id}
              className={'single-select'}
              placeholder={'Elegir empresa'}
              size={'large'}
              style={{ width: '100%' }}
              onChange={value => setStoreCompany(value)}
              getPopupContainer={trigger => trigger.parentNode}
            >
              {shopsList &&
                shopsList.map(data => {
                  return (
                    <Option key={data.id} value={data.id}>
                      {data.name}
                    </Option>
                  )
                })}
            </Select>
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>RTN*</div>
            <Input value={rtn} onChange={value => setRtn(value.target.value)} placeholder={'Escribir RTN'} size={'large'} max={14} />
          </Col>
        </Row>
        <Row gutter={16} className={'section-space-field'}>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Nombre comercial*</div>
            <Input value={tradename}
              onChange={value => setTradeName(value.target.value)}
              placeholder={'Escribir nombre comercial'}
              size={'large'} />
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Domicilio / Dirección*</div>
            <Input
              value={address}
              onChange={value => setEmisorAddress(value.target.value)}
              placeholder={'Escribe la dirección'}
              size={'large'} />
          </Col>
        </Row>

        <Row gutter={16} className={'section-space-field'}>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Razón Social*</div>
            <Input
              value={reason}
              onChange={value => setReason(value.target.value)}
              placeholder={'Escribe razon social'}
              size={'large'} />
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Correo del emisor*</div>
            <Input
              value={email}
              onChange={value => setEmisorEmail(value.target.value)}
              placeholder={'Escribe el correo'}
              size={'large'}
              type={'email'} />
          </Col>
        </Row>

        <Row gutter={16} className={'section-space-field'}>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Denominacion*</div>
            <Select
              disabled={loadingField}
              showSearch
              optionFilterProp="children"
              onSearch={onSearchEnterprise}
              value={denomination}
              className={'single-select'}
              placeholder={'Elegir denominacion'}
              size={'large'}
              style={{ width: '100%' }}
              onChange={value => setDenominationType(value)}
            >
              {denominationData.map(data => {
                return (
                  <Option key={data.id} value={data.id}>
                    {data.name}
                  </Option>
                )
              })}
            </Select>
          </Col>

          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Teléfono*</div>
            <Input placeholder={'Escribir telefono'} size={'large'} type={'number'} value={phone} onChange={value => setPhone(value.target.value)} />
          </Col>
        </Row>

        <Row gutter={16} className={'section-space-field'}>

          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Tipo de documento*</div>
            <Input value={documentType}
              onChange={value => setDocumentType(value.target.value)}
              placeholder={'Tipo de documento'}
              size={'large'}
              min={2}
              disabled={true}
            />
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Punto de emision*</div>
            <Input
              value={establishmentTaxpayer}
              onChange={value => setEstablishmentTaxpayer(value.target.value)}
              placeholder={'Escribe el punto de emision'}
              size={'large'}
              type={'number'}
              min={0}
              max={999}
            />
          </Col>
        </Row>

        <Row gutter={16} className={'section-space-field'}>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>CAI emisor*</div>
            <Cleave placeholder="CAI"
              options={{
                blocks: [6, 6, 6, 6, 6, 2],
                delimiter: "-",
                numericOnly: false
              }}
              value={cai}
              onChange={value => setCai(value.target.value)}
              className={'ant-input ant-input-lg'}
            />
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Fecha limite*</div>
            <DatePicker
              placeHolder={'Selecciona Fecha'}
              size={'large'}
              format={'YYYY-MM-DD'}
              className={'date-picker-custom'}
              disabledDate={current => current && current < moment().endOf('day')}
              value={!limitDate ? '' : moment(limitDate, 'YYYY-MM-DD')}
              onChange={onChangeBirthDate}
            />
          </Col>
        </Row>

        <Row gutter={16} className={'section-space-field'}>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Rango inicial*</div>
            <Input value={startRange}
              onChange={value => setStartRange(value.target.value)}
              placeholder={'Rango inicial'}
              size={'large'}
              type={'number'}
              min={0}
              max={endRange - 1}
            />

          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={'title-space-field'}>Rango final*</div>
            <Input
              value={endRange}
              onChange={value => setEndRange(value.target.value)}
              placeholder={'Escribe el código de escenario'}
              size={'large'}
              type={'number'}
              min={startRange + 1} />
          </Col>
        </Row>

        <Row gutter={16} className={'section-space-field'}>
          <Col xs={12} sm={12} md={12} lg={12} style={{ display: 'flex' }}>
            <span style={{ marginRight: '1rem' }} className={'label-bold-500 ratio-button-labels'}>¿Desea activar la credencial?</span>
            <Radio.Group
              className={'radio-group'}
              optionType="button"
              buttonStyle="solid"
              size={'large'}
              value={active}
              onChange={value => setActive(value.target.value)}
            >
              <Radio.Button value={false}>No</Radio.Button>
              <Radio.Button value={true}>Sí</Radio.Button>
            </Radio.Group>
          </Col>
        </Row>
      </Row>

      <Row gutter={16}>
        <Divider className={'divider-custom-margins-users'} />
        <Col xs={24} sm={24} md={24} lg={24}>
          <div className="text-right">
            <div>
              <Button type={'link'} className="cancel-button" onClick={() => props.cancelButton()}>
                Cancelar
              </Button>
              <Button htmlType="submit" className="title-tendero new-button" onClick={() => saveData()}>
                Guardar
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </Drawer>
  )
}

export default FelDrawer
